import React from 'react';
import { Quote } from 'lucide-react';

// A warmer, more personal note from Teacher Kalah — repurposed from the
// previous "Our Philosophy" block (which overlapped with the new
// "What Makes Read Right Academy Different?" section).

const PhilosophySection = () => {
  return (
    <section
      id="philosophy"
      data-testid="note-from-kalah"
      className="py-20 px-4 sm:px-6 lg:px-8 bg-white"
    >
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-block bg-rose-50 text-rose-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            A Note from Teacher Kalah
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
            Why I do this work
          </h2>
        </div>

        <div className="relative bg-gradient-to-br from-slate-50 via-white to-blue-50/40 rounded-3xl p-8 sm:p-12 border border-slate-100 shadow-sm">
          {/* Big quote mark */}
          <Quote
            aria-hidden="true"
            className="absolute -top-4 -left-2 sm:-top-5 sm:-left-3 h-14 w-14 sm:h-16 sm:w-16 text-[#3B4BA0]/15 fill-[#3B4BA0]/10"
          />

          <div className="space-y-5 text-base sm:text-lg text-gray-700 leading-relaxed">
            <p>
              Reading should never begin with pressure. It begins quietly — with
              listening, sound awareness, and a child who feels safe enough to try.
            </p>
            <p>
              Over the years, I have watched children blossom when they are taught in
              ways that match how they truly learn. They stop saying,{' '}
              <em>&ldquo;I can&apos;t read,&rdquo;</em> and begin asking,{' '}
              <em>&ldquo;What does this word say?&rdquo;</em>
            </p>
            <p className="text-xl sm:text-2xl font-semibold text-[#2d3a7a] italic border-l-4 border-[#3B4BA0] pl-5 my-6">
              A child needs confidence, readiness, sound awareness, listening
              skills, vocabulary, and meaningful interaction before reading can
              begin to feel natural.
            </p>
            <p>
              That belief is at the heart of Read Right Academy — and it is the
              reason I continue to teach, train, and learn alongside every child,
              parent, and educator who joins us.
            </p>
          </div>

          {/* Signature */}
          <div className="mt-10 flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#3B4BA0] to-teal-500 text-white flex items-center justify-center font-bold text-lg shadow-md">
              K
            </div>
            <div>
              <p className="font-bold text-gray-900 leading-tight">
                Kalah K. Singam
              </p>
              <p className="text-sm text-gray-500">
                Founder · Teacher · Early Childhood Educator
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
